import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  heading: {
    margin: 0,
    fontSize: theme.typography.h6.fontSize,
    fontWeight: 700,
    '&:focus': {
      outline: 'none',
    },
  },
  hint: {
    margin: 0,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
  },
  list: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));

export default useStyles;
